import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import DateTimeDisplay from '../../components/DateTimeDisplay'
import DetailPageTemplate from '../../templates/DetailPageTemplate'
import fetchWithAuth from '../../utilities/fetchWithAuth'

const DataTypePage = () => {
  const [dataType, setDataType] = useState(null)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const { uuid } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await fetchWithAuth(`data-types/${uuid}`)
        setDataType(data)
      } catch (error) {
        console.error('Error fetching data type:', error)
      }
    }

    fetchData()
  }, [uuid])

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false)
  }

  const handleDelete = async () => {
    try {
      await fetchWithAuth(`data-types/${uuid}`, { method: 'DELETE' })
      navigate('/data-types')
    } catch (error) {
      console.error('Error deleting data type:', error)
    }
  }

  if (!dataType) {
    return <DetailPageTemplate isLoading={true} />
  }

  const detailsSection = {
    title: 'Data Type Details',
    content: (
      <Card variant="outlined">
        <CardContent>
          <Stack spacing={3}>
            <Box display="flex" alignItems="flex-start" gap={2}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ width: 500, flexShrink: 0 }}
              >
                Name
              </Typography>
              <Typography>{dataType.name}</Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" gap={2}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ width: 500, flexShrink: 0 }}
              >
                Slug
              </Typography>
              <Typography>{dataType.slug}</Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" gap={2}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ width: 500, flexShrink: 0 }}
              >
                Subtype
              </Typography>
              <Typography>{dataType.subtype}</Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" gap={2}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ width: 500, flexShrink: 0 }}
              >
                Analysis
              </Typography>
              <Typography>{dataType.analysisId?.name || '-'}</Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" gap={2}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ width: 500, flexShrink: 0 }}
              >
                Created At
              </Typography>
              <DateTimeDisplay date={new Date(dataType.createdAt)} />
            </Box>
            <Box display="flex" alignItems="flex-start" gap={2}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ width: 500, flexShrink: 0 }}
              >
                Updated At
              </Typography>
              <DateTimeDisplay date={new Date(dataType.updatedAt)} />
            </Box>
          </Stack>
        </CardContent>
      </Card>
    ),
  }

  return (
    <>
      <DetailPageTemplate
        title={dataType.name}
        breadcrumbs={['data-types', dataType.name]}
        actions={
          <Stack direction="row" spacing={2}>
            <Button
              component={Link}
              to={`/data-types/${uuid}/edit`}
              variant="contained"
              color="primary"
            >
              Edit
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={() => setOpenDeleteDialog(true)}
            >
              Delete Data Type
            </Button>
          </Stack>
        }
        sections={[detailsSection]}
      />

      <Dialog open={openDeleteDialog} onClose={handleCloseDialog}>
        <DialogTitle>Delete Data Type</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {dataType.name}? This action cannot
            be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleDelete} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DataTypePage
